import { render, staticRenderFns } from "./siteAdminProfileForm.vue?vue&type=template&id=f3a564dc&scoped=true&"
import script from "./siteAdminProfileForm.vue?vue&type=script&lang=babel&"
export * from "./siteAdminProfileForm.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3a564dc",
  null
  
)

export default component.exports